import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

import { Breakpoint, BreakpointKey, CssUtils } from '@hdms/shared/util-core';

export type NavUrlType = 'routerLink' | 'default';

const DEFAULT_FULL_IMG_SIZE = CssUtils.baseLine * 6;
const COMPRESSED_FULL_IMG_SIZE = CssUtils.baseLine * 4;
const PRODUCT_IMG_SCALE = 0.7;

@Component({
  selector: 'shrd-uic-nav-button',
  templateUrl: './nav-button.component.html',
  styleUrls: ['./nav-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NavButtonComponent {
  @Input() label: string;
  @Input() url?: string | any[];
  @Input() urlType?: NavUrlType;
  @Input() headlineText?: string;
  @Input() imgUrl?: string;
  @Input() imgAlt?: string;
  @Input() isTextIndent = false;
  @Input() isTopAligned = false;
  @Input() isSelected = false;
  @Input() disabled = false;
  @Input() usePlaceholder = false;
  @Input() showWarningIndicator = false;
  @Input() useImageVariant = false;
  @Input() maxBreakpoint: BreakpointKey = Breakpoint.SM;
  @Input()
  set isImageCoverMode(useFullImgSize: boolean) {
    this.useFullImgSize = useFullImgSize;
    const fullImgSize = this.isCompressed ? COMPRESSED_FULL_IMG_SIZE : DEFAULT_FULL_IMG_SIZE;
    this.maxImgSize = useFullImgSize ? `${fullImgSize}` : (fullImgSize * PRODUCT_IMG_SCALE).toFixed();
  }
  get isImageCoverMode(): boolean {
    return this.useFullImgSize;
  }

  @Input() maxImgSize = (DEFAULT_FULL_IMG_SIZE * PRODUCT_IMG_SCALE).toFixed();

  @Input()
  set isCompressed(isCompressedButton: boolean) {
    this.isCompressedButton = isCompressedButton;
    this.isImageCoverMode = this.useFullImgSize;
  }

  get isCompressed(): boolean {
    return this.isCompressedButton;
  }

  @HostBinding('class.is-compressed')
  get hostClass(): boolean {
    return this.isCompressedButton;
  }
  private useFullImgSize = false;
  private isCompressedButton = false;
}
